import React, { useState, useEffect, useContext } from "react";
import { redirect, useNavigate, useParams } from "react-router-dom";
import {
  getDataByUserId,
  getPatientByPraxisId,
} from "../../../firebase/firebase.patient";
import Legals from "../patientViews/allViews/legal/Legals";
import Navbar from "../../navbar/Navbar";
import HeaderActions from "../../UI/HeaderActions";
import { ClientViewContext } from "../../../context/clientView/clientView.context";
import Odontogram from "./patientInformation/odontogram/Odontogram 2";
import History from "../patientViews/allViews/history/History";
import Payments from "../patientViews/allViews/payments/Payments";
import { useSelector } from "react-redux";
import Spinner from "../../UI/Spinner";
import PatientStats from "./patientStats/PatientStats";
import AddPatient from "../addPatient/AddPatient";
import ImgDashboard from "../patientViews/allViews/imgDashboard/ImgDashboard";
import FeatureFlag from "../../featureFlag/FeatureFlag";

const PatientOverview = () => {
  const [data, setData] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const { state, dispatch } = useContext(ClientViewContext);
  const localPraxis = useSelector((state) => state.user?.userDetails);
  let params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (params.id !== clientId) {
      setClientId(params.id);
    }
  }, [params.id]);

  useEffect(() => {
    let getNewData = async () => {
      let data = await getPatientByPraxisId(localPraxis.praxisId, params.id);
      if (data !== undefined) {
        data.praxisName = localPraxis.praxis;
        // data.appointmentStart = "12/12/2024";
        setData(data);
      } else {
        navigate("/dashboard");
      }
    };
    if (clientId && localPraxis) {
      getNewData();
    }
  }, [clientId, localPraxis]);

  return (
    <>
      <Navbar>
        {data ? (
          <>
            <main
              className="flex flex-wrap bg-slate-800 h-full"
              style={{ justifyContent: "center" }}
            >
              <div className="mx-auto w-full">
                <div className="w-full bg-white rounded-t-lg h-full">
                  <div className="flex"></div>
                  <div className="flex">
                    <div className="bg-white rounded-t-lg w-full max-h-[91vh]">
                      {data && (
                        <PatientStats
                          stats={data}
                          showmoreSetter={setShowMore}
                        />
                      )}
                      {data && (
                        <HeaderActions
                          title={"Agregar Usuario"}
                          userId={data.id}
                        />
                      )}
                      {state && data && state.clientView === "Ficha" && (
                        <div
                        // className={`${!data && "m-5"}`}
                        >
                          <AddPatient
                            headerTitle={`${data.personalDetails.name}`}
                            data={data}
                            setData={setData}
                            editMode={false}
                            showMore={showMore}
                          />{" "}
                        </div>
                      )}
                      {state && data && state.clientView === "Legal" && (
                        <div className="m-5 bg-white">
                          <Legals
                            headerTitle={`${data.personalDetails.name}`}
                            data={data}
                            editMode={false}
                          />{" "}
                        </div>
                      )}
                      {state && data && state.clientView === "Img" && (
                        <div className="">
                          <FeatureFlag feature={"premium"}>
                            <ImgDashboard
                              data={data}
                              userId={data.id}
                              praxisId={data.praxisId}
                              user={localPraxis}
                            />{" "}
                          </FeatureFlag>
                        </div>
                      )}
                      {state && data && state.clientView === "Odontograma" && (
                        <div className="mt-2">
                          <Odontogram data={data} />
                        </div>
                      )}
                      {state && data && state.clientView === "Historial" && (
                        <div className="m-5">
                          <History
                            rawHistory={data.history}
                            data={data}
                            patientId={clientId}
                            praxisName={localPraxis.praxis}
                            showMoreStatus={showMore}
                          />
                        </div>
                      )}
                      {state && data && state.clientView === "Pagos" && (
                        // <div className="m-5">
                        <Payments data={data} />
                        // </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </>
        ) : (
          <div
            className="flex items-center justify-center bg-white rounded-t-lg"
            style={{ height: "90.7vh" }}
          >
            <Spinner />
          </div>
        )}
      </Navbar>
    </>
  );
};

export default PatientOverview;
